module.exports = __webpack_public_path__ + "img/jb_t-7271_3_94.prt.db86753d.jpg";